<template>
  <div id="page-add-supplier">
    <vs-card>
      <div class="vx-row pt-5 px-5">
        <div class="vx-col md:w-1/2 px-8">
          <div class="vx-col">
            <div class="vx-row mb-2">
              <label>Bussiness Name <span class="text-danger">*</span></label>
              <vs-input icon="icon icon-user" v-model="form.business_name" icon-pack="feather" class="w-full" v-validate="'required'" name="Business Name" />
              <span class="text-danger text-sm" v-show="errors.has('Business Name')">{{ errors.first('Business Name') }}</span>
            </div>

            <!-- <div class="vx-row mb-2">
              <vs-input icon="icon icon-phone" v-model="form.phone" icon-pack="feather" class="w-full" label="Mobile" name="Mobile" />
            </div> -->

            <!-- <div class="vx-row mb-2">
              <vs-input icon="icon icon-mail" v-model="form.email" icon-pack="feather" class="w-full" label="Email" name="Email" />
            </div> -->

            <div class="vx-row mb-2">
              <vs-input icon="icon icon-award" v-model="form.license_number" icon-pack="feather" class="w-full" label="License Number" name="License Number" />
            </div>

            <!-- <div class="vx-row mb-2">
              <vs-input icon="icon icon-map-pin" v-model="form.address" icon-pack="feather" class="w-full" label="Address" name="Address" />
            </div> -->

            <div class="vx-row mb-2">
              <vs-input icon="icon icon-user-check" v-model="form.contact_name" icon-pack="feather" class="w-full" label="Contact Name" name="Contact Name" />
            </div>
          </div>
        </div>
        <div class="vx-col md:w-1/2 px-8">
          <!-- <div class="vx-row mb-2">
            <vs-input icon="icon icon-map-pin" v-model="form.postcode" icon-pack="feather" class="w-full" label="Zip Code" name="Zip Code" />
          </div> -->

          <div class="vx-row mb-3">
            <label>Role <span class="text-danger">*</span></label>
            <select-2
              autocomplete
              class="w-full"
              :value="form.role"
              @input="(item) => (form.role = item && item.value)"
              label-placeholder="Role"
              name="Role"
              placeholder="Select Role"
              :options="roleOptions"
              v-validate="'required'"
            />
            <span class="text-danger text-sm" v-show="errors.has('Role')">{{ errors.first('Role') }}</span>
          </div>

          <!-- <div class="vx-row mb-2">
            <vs-input icon="icon icon-map-pin" v-model="form.state" icon-pack="feather" class="w-full" label="State" name="State" />
          </div> -->

          <!-- Expiry Date -->
          <div class="vx-row mb-2">
            <label for="">License Expiry Date</label>
            <date-picker :appendToBody="false" v-model="form.license_expiry_date" placeholder="MM-DD-YYYY" format="MM-DD-YYYY" valueType="format" class="w-full" />
          </div>
          <!-- note -->
          <div class="vx-row mb-2">
            <vs-input icon="icon icon-edit" v-model="form.note" icon-pack="feather" class="w-full" label="Note" name="Note" />
          </div>
        </div>
      </div>

      <!-- form - vertical tabs -->
      <div class="mt-10">
        <vs-tabs ref="tabs" v-model="activeTab" position="left">
          <vs-tab label="More Information">
            <more-information-tab ref="moreInformationTab" :form.sync="form" />
          </vs-tab>
          <vs-tab label="Reward Points">
            <reward-points-tab ref="rewardpointsTab" :form.sync="form" clientType="update" />
          </vs-tab>
          <vs-tab label="Discount Status">
            <discount-status-tab ref="discountstatusTab" :form.sync="form" />
          </vs-tab>
        </vs-tabs>
      </div>

      <!-- Save & Reset Button -->
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="mt-8 flex flex-wrap items-center justify-start">
            <vs-button class="mr-2 vs-con-loading__container" id="add-client-button" type="relief" @click="save_changes" :disabled="!validateForm || loading">Save Changes</vs-button>
            <vs-button to="/clients/list" color="danger" type="relief" class="text-left">Cancel</vs-button>
          </div>
        </div>
      </div>
    </vs-card>
  </div>
</template>

<script>
import { clientRoleOptions } from '@/utils/enums'
import moment from 'moment'
import Select2 from '@/components/custom/form-elements/Select2.vue'
import MoreInformationTab from '../clients/components/MoreInformationTab.vue'
import RewardPointsTab from '../clients/components/RewardPointsTab.vue'
import DiscountStatusTab from '../clients/components/DiscountStatusTab.vue'
import { dateMixins } from '@/mixins/dateMixins.js'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

export default {
  name: 'EditClient',

  components: {
    Select2,
    MoreInformationTab,
    RewardPointsTab,
    DiscountStatusTab,
    DatePicker
  },

  data: () => ({
    loading: false,
    form: {
      business_name: '',
      phone: '',
      email: '',
      license_number: '',
      address: '',
      contact_name: '',
      postcode: '',
      role: null,
      state: '',
      note: '',
      license_expiry_date: null,
      taxDiscountId: null,
      promoDiscountId: null,
      reward_points: 0,
      customerStatusIds: [],
      dob: null
    },
    roleOptions: clientRoleOptions,
    activeTab: 0
  }),

  mixins: [dateMixins],

  async mounted() {
    const { id } = this.$route.params
    this.loading = true
    this.$store
      .dispatch('client/get', id)
      .then(({ data }) => {
        this.loading = false
        const { client } = data
        this.form.business_name = client.business_name
        this.form.phone = client.phone
        this.form.email = client.email
        this.form.license_number = client.license_number
        this.form.address = client.address
        this.form.state = client.state
        this.form.postcode = client.postcode
        this.form.contact_name = client.contact_name
        this.form.note = client.note
        this.form.role = client.role
        this.form.taxDiscountId = client.taxDiscountId
        this.form.promoDiscountId = client.promoDiscountId
        this.form.reward_points = client.reward_points
        this.form.customerStatusIds = client.customerStatusIds
        this.form.license_expiry_date = moment(client.license_expiry_date).format('MM-DD-YYYY')
        this.form.dob = moment(client.dob).format('MM-DD-YYYY')
      })
      .catch((err) => {
        const { message } = err
        this.loading = false
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
  },

  computed: {
    validateForm() {
      return !this.errors.any()
    }
  },

  methods: {
    async save_changes() {
      if (!(await this.$validator.validate())) {
        return false
      }
      this.loading = true
      this.$store
        .dispatch('client/update', {
          id: this.$route.params.id,
          data: { ...this.form, dob: moment(this.form.dob).format('YYYY-MM-DD'), license_expiry_date: moment(this.form.license_expiry_date).format('YYYY-MM-DD') }
        })
        .then(() => {
          this.loading = false
          this.$router.push({ name: 'client-list' })

          this.$vs.notify({
            title: 'Success',
            text: 'Client Update successfully!',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
        })
        .catch((err) => {
          const { message } = err
          this.loading = false
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    }
  },

  watch: {
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '#add-client-button',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#add-client-button > .con-vs-loading')
      }
    }
  }
}
</script>

<style>
.vdp-datepicker__calendar {
  max-width: 300px;
}
</style>